// extracted by mini-css-extract-plugin
export default {"star-container":"star-container_star-container__-TYZr","stars":"star-container_stars__1mDzd","starsMove":"star-container_starsMove__hvXKw"};